import React, { ReactElement } from 'react';
import { Container, TabItem } from './styles';

export const TabHeader = ({ items, selectedTab, onSelect }: TabHeaderProps) => {
  return (
    <Container className="tabHeader">
      {items.map((tab) => (
        <TabItem
          key={tab.key}
          selected={tab.key === selectedTab?.key}
          onClick={() => onSelect(tab)}
          data-cy={`tab_${tab.key}`}
        >
          {tab.label}
        </TabItem>
      ))}
    </Container>
  );
};

export interface TabHeaderProps {
  items: Tab[];
  selectedTab?: Tab;
  onSelect: (tab: Tab) => void;
}

export interface Tab {
  key: string;
  label: string | ReactElement;
}
